<ng-container>
  @if (order$ | async; as order) {
    <div
      class="loan-information-section"
      >
      <div class="mb-4">
        <h2>Key Info</h2>
      </div>
      @if (!toggleLoanInformationFormEdit) {
        <div class="row">
          <div class="col">
            <label>Property Address</label>
            @if (order?.propertyAddress) {
              <div>
                <div data-cy="streetAddress">
                  {{ order?.propertyAddress.streetAddress1 }}
                </div>
                <div data-cy="cityStateZip">
                  {{ order?.propertyAddress.city }}
                  {{ order?.propertyAddress.stateCode }}
                  {{ order?.propertyAddress.zipCode }}
                </div>
              </div>
            } @else {
              <ion-skeleton-text animated></ion-skeleton-text>
            }
          </div>
          <div class="col">
            <label>Signing Type</label>
            @if (order) {
              <div
                data-cy="signingType"
                >
                <span>{{ order?.productType | closingTypeValue }}</span>
              </div>
            } @else {
              <ion-skeleton-text animated></ion-skeleton-text>
            }
          </div>
          <div class="col">
            <label>
              Scheduled Date/Time <mat-icon class="tooltip-icon" style="height: 1.3rem; width: 1rem;" matTooltip="Time is based on the property address' time zone." matTooltipPosition="below" matTooltipShowDelay="500" svgIcon="information"></mat-icon>
            </label>
            @if (order?.scheduledDateTime) {
              <div
                data-cy="scheduledDateTime"
                >
                <span>{{ scheduledTime$ | async | date: "medium" }}</span>
              </div>
            } @else {
              <ion-skeleton-text animated></ion-skeleton-text>
            }
          </div>
          <div class="col">
            <label>Order Status</label>
            @if (orderStatus$ | async; as orderStatus) {
              @if (orderStatus == 'OPTOUT' || orderStatus == 'CANCELLED') {
                <a
                  type="button"
                  class="nav-link"
                  (click)="openCommentsModal()"
                  >
                  (View Comments)
                </a>
              }
              <ng-container
            [ngTemplateOutlet]="
              (orderStatus === 'CANCELLED' || orderStatus === 'OPTOUT') &&
              order?.orderStatusDetail?.categoryTypeValue
                ? cancelledOrOptOutOrderStatus
                : defaultOrderStatus
            "
            [ngTemplateOutletContext]="{
              order: order,
              orderStatus: orderStatus
            }"
              ></ng-container>
            }
          </div>
          <div class="col">
            <label>Loan Number</label>
            <div data-cy="loanIdentifier">
              {{ order?.loanIdentifier }}
            </div>
          </div>
          <div class="col">
            <label>3rd Party Order ID</label>
            <div data-cy="thirdPartyOrderIdentifier">
              {{ order?.thirdPartyOrderIdentifier }}
            </div>
          </div>
          @if (order?.productType !== 'RIW') {
            <div class="col">
              <label>Pre-Sign</label>
              @if (order) {
                <div>
                  <span
                    >@if (isOrderPreSign) {
                    <span
                      class="fas fa-check-circle primary-color-txt stand-alone-icon-tables"
                      data-cy="presignEnabled"
                      ></span
                      >
                    }</span>
                  </div>
                } @else {
                  <ion-skeleton-text animated></ion-skeleton-text>
                }
              </div>
            }
            @if (isOrderManager && (isPortalAssigneeEnabled$ | async)) {
              <div class= "col">
                <label>Assignee</label>
                <ng-select
                  class="assignee-dropdown"
                  [items]="(assignees$ | async)"
                  bindLabel="fullName"
                  [virtualScroll]="true"
                  [clearable]="false"
                  [searchFn]="assigneeSearchFn"
                  bindValue="accountId"
                  labelForId="assignees"
                  placeholder="No assignee"
                  (change)="setAssignee($event)"
                  [placeholder]="currentAssigneeName"
                  >
                  <ng-template ng-option-tmp let-item="item">
                    <div
                      class="text-truncate"
                      ngbTooltip="{{ item.fullName }} {{item.emailAddress}}"
                      placement="right"
                      container="body"
                      openDelay="500"
                      >
                      <span class="fw-bold">{{item.fullName}}</span> <div class="emailAddress text-truncate">{{item.emailAddress}}</div>
                    </div>
                  </ng-template>
                  <ng-template ng-label-tmp let-item="item" let-search="searchTerm" let-index="index">
                    <div class="text-truncate">
                      {{item.fullName}}
                    </div>
                  </ng-template>
                </ng-select>
              </div>
            }
          </div>
        }
      </div>
    } @else {
      <div class="loan-information-section">
        @if (!toggleLoanInformationFormEdit) {
          <div
            class="row marginTopFifteenPx"
            >
            <div class="col">
              <label>Property Address</label>
              <ion-skeleton-text animated></ion-skeleton-text>
              <ion-skeleton-text animated></ion-skeleton-text>
            </div>
            <div class="col">
              <label>Signing Type</label>
              <ion-skeleton-text animated></ion-skeleton-text>
            </div>
            <div class="col">
              <label>Scheduled Date/Time</label>
              <ion-skeleton-text animated></ion-skeleton-text>
            </div>
            <div class="col">
              <label>Order Status</label>
              <ion-skeleton-text animated></ion-skeleton-text>
            </div>
            <div class="col">
              <label>Pre-Sign</label>
              <ion-thumbnail slot="start" style="height: 1rem; width: 1rem">
                <ion-skeleton-text></ion-skeleton-text>
              </ion-thumbnail>
            </div>
          </div>
        }
      </div>
    }
    <ng-template
      #defaultOrderStatus
      let-orderStatus="orderStatus"
      let-order="order"
      >
      <div data-cy="orderStatus">
        <span>{{ orderStatus | titleCaseStatusCode }}</span>
      </div>
    </ng-template>
    <ng-template
      #cancelledOrOptOutOrderStatus
      let-orderStatus="orderStatus"
      let-order="order"
      >
      @if (orderStatusDetails$ | async; as orderStatusDetails) {
        @for (detail of orderStatusDetails.orderStatusDetails; track detail) {
          <div
            data-cy="orderStatus"
            >
            <span
              >{{ orderStatus | titleCaseStatusCode }} -
              {{ detail.categoryTypeValue }}</span
              >
            </div>
          }
        }
      </ng-template>
    </ng-container>
